import { render, staticRenderFns } from "./procurementNotice.vue?vue&type=template&id=482c0d2e&scoped=true"
import script from "./procurementNotice.vue?vue&type=script&lang=js"
export * from "./procurementNotice.vue?vue&type=script&lang=js"
import style0 from "./procurementNotice.vue?vue&type=style&index=0&id=482c0d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c0d2e",
  null
  
)

export default component.exports